import type { FaireProductEntity } from "../../entity_types/product";

export const p_v9vh5q5drf: FaireProductEntity = {
  token: "p_v9vh5q5drf",
  type: "product",
  name: "Arnica Salve",
  brandToken: "b_rvn46uxywb",
  brandName: "Holistic Homestead",
  imageUrl:
    "https://cdn.faire.com/fastly/5712f517a075b0874d6ce1e75ebddae0ac5e50497f0ae5bde0da2df90aeff088.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description:
    "Arnica is well known for it's ability to reduce bruising & swelling. When used topically it can help increase blood flow to the area, in turn accelerating the healing process and reducing pain. This is a great salve to have on hand for bumps, bruises, strains, sprains, and achy joints. \n\nArnica is a key ingredient in our Sore Muscle Salve which has much more herbal support for muscle soreness & pain. Arnica salve is our choice for bumps & bruises especially for use on children. External use only. Do not use on broken skin.\n\n1 oz. Tin",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:47.527Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
